import { ScheduleOriginSecondaryFeature } from '@chilipiper/api-client/src/meetings'
import { ProductFeatureV3 } from '@chilipiper/api-client/src/user-availability'

export const getIndividualSchedulingLinkProductFeature = (productFeature?: ProductFeatureV3) => {
  if (
    productFeature?.type === 'AdminIndividualSchedulingLink' ||
    productFeature?.type === 'PersonalIndividualSchedulingLink'
  ) {
    return productFeature
  }

  return
}

export const getLinkProductFeature = (productFeature?: ProductFeatureV3) => {
  if (
    productFeature?.type === 'AdminIndividualSchedulingLink' ||
    productFeature?.type === 'PersonalIndividualSchedulingLink' ||
    productFeature?.type === 'RoundRobinSchedulingLink' ||
    productFeature?.type === 'OwnershipSchedulingLink' ||
    productFeature?.type === 'GroupSchedulingLink'
  ) {
    return productFeature
  }

  return
}

// Used on booking app only to get to know the feature based on the URL
export const getSecondaryFeature = (
  pathname: string,
  oneClickBooking = false
): ScheduleOriginSecondaryFeature[] => {
  const secondaryFeatures: ScheduleOriginSecondaryFeature[] = []
  const pathArray = pathname.split('/')

  if (pathArray.includes('once')) {
    secondaryFeatures.push('OneTimeLink')
  }

  if (pathArray.includes('suggested-times')) {
    secondaryFeatures.push('SuggestedTimes')
  }

  if (oneClickBooking) {
    secondaryFeatures.push('OneClickBooking')
  }

  return secondaryFeatures
}
